export const SPAYEE_API = process.env.NEXT_PUBLIC_SPAYEE_API;

export const SPAYEE_URL = process.env.NEXT_PUBLIC_SPAYEE_URL;

export const ROOT_HOST_NEW = process.env.NEXT_PUBLIC_ROOT_HOST_NEW;

export const OTP_VERIFICATION = {
  EMAIL_VERIFICATION: "email_verification",
  RESEND_OTP: "resend_otp",
};

export const SIGNIN_TYPE = {
  OTP: "otp",
  GOOGLE: "google",
  EMAIL: "email",
};
